import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsCidadeClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/cidade');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Cidade');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/cidade', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Cidade');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/cidade', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Cidade');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/cidade/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Cidade');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/cidade/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Cidade');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/cidade/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Cidade');
    }
  }
}
